import { ChangeEvent, ReactNode } from 'react';

interface UrlFieldProps {
    heading: string;
    description: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    formSubmitted: boolean;
    isDuplicate: boolean;
    disabled: boolean;
    baseInputClass: string;
    fullUrlPreview: string;
}

export const UrlField = ({
    heading,
    description,
    value,
    onChange,
    formSubmitted,
    isDuplicate,
    disabled,
    baseInputClass,
    fullUrlPreview
}: UrlFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        <p className={`text-sm mb-4 break-words ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            {description}
        </p>
        <input
            type="text"
            id="assistantUrl"
            className={`${baseInputClass} ${(formSubmitted && !value) || isDuplicate
                ? 'border-jtc-pink focus:border-jtc-pink'
                : 'border-jtc-grey focus:border-jtc-blue focus:ring-1 focus:ring-jtc-blue focus:outline-none'
                }`}
            placeholder={formSubmitted && !value ? 'An assistant URL is required...' : 'e.g. screening'}
            value={value}
            onChange={onChange}
        />
        <div className="mt-2 text-sm">
            <span className="text-gray-500">Preview: </span>
            <span className="text-jtc-very-dark-grey break-all">{fullUrlPreview}</span>
        </div>
        {isDuplicate && (
            <div className="mt-1 text-sm text-red-600">
                URL is already in use. Please choose another.
            </div>
        )}
    </>
);
